
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/details",
      function () {
        return require("private-next-pages/shops/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/details"])
      });
    }
  